import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_DE: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io vs innRoad',
  heroSubtitle: 'innRoad ist ein US-basiertes Cloud-PMS fuer unabhaengige Hotels mit einem grundlegenden Funktionsumfang. HotelStack.io bietet 36 Module einschliesslich fortschrittlichem Ertragsmanagement, F&B/POS, Multi-Property-Support und globaler Compliance — zu einem vergleichbaren Preis.',
  overviewComparison: [
    { label: 'Module gesamt', hotelstack: '36 integrierte Module', competitor: '8+ Kernfunktionen' },
    { label: 'Preise', hotelstack: 'Ab $49/Monat', competitor: 'Ab $100+/Monat' },
    { label: 'Multi-Property', hotelstack: 'Vollstaendige Kettenverwaltung', competitor: 'Nicht unterstuetzt' },
    { label: 'F&B / POS', hotelstack: 'Integriert', competitor: 'Nicht verfuegbar' },
    { label: 'Globale Reichweite', hotelstack: 'Ueber 40 Laender', competitor: 'US-fokussiert' },
    { label: 'Ertragsmanagement', hotelstack: 'Erweitert (integriert)', competitor: 'Basis-Tariftools' },
  ],
  featureTable: [
    {
      category: 'Kern-PMS',
      features: [
        { name: 'Cloud-basiertes PMS', hotelstack: true, competitor: true },
        { name: 'Visuelle Zimmertafel', hotelstack: true, competitor: true },
        { name: 'Reservierungsverwaltung', hotelstack: true, competitor: true },
        { name: 'Nachtabschluss-Assistent', hotelstack: true, competitor: true },
        { name: 'Gastefolio-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Online Check-In Portal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Distribution & Buchung',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'Begrenzte OTAs' },
        { name: 'GDS-Anbindung', hotelstack: true, competitor: true },
        { name: 'Provisionsfreie Buchungsmaschine', hotelstack: true, competitor: true },
        { name: 'Gruppenbuchungen', hotelstack: true, competitor: 'Basis' },
        { name: 'Firmentarif-Verwaltung', hotelstack: true, competitor: 'Eingeschraenkt' },
      ],
    },
    {
      category: 'Ertragsmanagement',
      features: [
        { name: 'Dynamische Preisregeln', hotelstack: true, competitor: 'Basis' },
        { name: 'Was-Waere-Wenn-Ertragssimulator', hotelstack: true, competitor: false },
        { name: 'Wettbewerbspreise-Monitor', hotelstack: true, competitor: false },
        { name: 'Nachfrageprognose', hotelstack: true, competitor: false },
        { name: 'RevPAR-Analysen', hotelstack: true, competitor: 'Basis' },
      ],
    },
    {
      category: 'Betrieb & F&B',
      features: [
        { name: 'POS-Terminal', hotelstack: true, competitor: false },
        { name: 'Zimmerservice-Modul', hotelstack: true, competitor: false },
        { name: 'Housekeeping-Verwaltung', hotelstack: true, competitor: 'Basis' },
        { name: 'Wartungsauftraege', hotelstack: true, competitor: false },
        { name: 'Personalplanung', hotelstack: true, competitor: false },
        { name: 'Kuechenanzeigesystem', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Berichte & Compliance',
      features: [
        { name: 'Flash-Bericht', hotelstack: true, competitor: true },
        { name: 'Gewinn- und Verlustrechnung', hotelstack: true, competitor: false },
        { name: 'Pace-Bericht', hotelstack: true, competitor: false },
        { name: 'Mehrwaehrungsabrechnung', hotelstack: true, competitor: false },
        { name: 'Regionale Steuerkonformitaet', hotelstack: true, competitor: 'Nur USA' },
        { name: 'Benutzerdefinierter Berichtsgenerator', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resilienz & Offline',
      features: [
        { name: 'Offlinefaehige PWA', hotelstack: true, competitor: false },
        { name: 'Offline-Warteschlange fuer Aenderungen', hotelstack: true, competitor: false },
        { name: 'Hintergrundsynchronisierung bei Wiederverbindung', hotelstack: true, competitor: false },
        { name: 'Konfliktbewusster Abgleich', hotelstack: true, competitor: false },
        { name: 'Installierbare Rezeption', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Firmenkunden & Gruppenverkauf',
      features: [
        { name: 'Firmenratenverwaltung', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Gruppenbuchung mit Zimmerlisten', hotelstack: true, competitor: 'Basis' },
        { name: 'Offene-Posten- & Produktionsberichte', hotelstack: true, competitor: false },
        { name: 'Restaurantreservierungen', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal & HR',
      features: [
        { name: 'Mitarbeiterverzeichnis & Dienstplanung', hotelstack: true, competitor: false },
        { name: 'Lohnabrechnung', hotelstack: true, competitor: false },
        { name: 'Urlaub & Anwesenheit', hotelstack: true, competitor: false },
        { name: 'Leistungsanalysen', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'Alle 36 Module enthalten. Globale Mehrwaehrungsunterstuetzung. Regionale Preise in EUR, GBP, AED, INR, THB. Kostenloses Onboarding und Migration.',
    competitorNote: 'Angebotsbasierte Preise ab $100+/Monat. US-fokussiert mit eingeschraenkten internationalen Funktionen. Grundlegender Funktionsumfang ohne F&B, ohne Multi-Property, ohne erweiterte Analysen.',
  },
  advantages: [
    'Viermal so viele Module (36 vs. 8+) zu etwa der Haelfte des Einstiegspreises',
    'Vollstaendige Multi-Property-Kettenverwaltung — innRoad unterstuetzt nur Einzelobjekte',
    'Vollstaendiges F&B-Modul mit POS, Zimmerservice, Kuechenanzeige und Menueverwaltung',
    'Fortschrittliches Ertragsmanagement mit dynamischer Preisgestaltung, Prognose und Simulatoren',
    'Globale Reichweite in ueber 40 Laendern vs. innRoad nur USA-Fokus',
    'Mehrwaehrungsabrechnung und regionale Steuerkonformitaet fuer internationale Objekte',
    'Treueprogramm, Gaeste-CRM und automatisierte Kommunikation inklusive',
    'Kostenloses Onboarding und Datenmigration mit 24/7 dediziertem Support',
  ],
  verdict: {
    title: 'Unser Fazit',
    summary: 'innRoad ist ein einfaches Cloud-PMS fuer US-basierte unabhaengige Hotels, die grundlegende Reservierungs- und Rezeptionsverwaltung benoetigen. HotelStack.io bietet eine deutlich umfassendere Plattform mit viermal so vielen Modulen, Multi-Property-Support, F&B/POS, erweiterten Ertragstools und globaler Reichweite — alles zu einem niedrigeren Preis. Fuer jedes Hotel, das ueber grundlegende PMS-Beduerfnisse hinauswachsen moechte, ist HotelStack.io die klare Wahl.',
    bestFor: [
      'Unabhaengige Hotels, die von einem grundlegenden PMS auf eine vollstaendige Plattform upgraden moechten',
      'Objekte, die F&B, POS und Betriebstools benoetigen, die innRoad nicht bietet',
      'Hotels, die international expandieren und Mehrwaehrungs- und Compliance-Tools benoetigen',
      'Objekte, die Multi-Property-Verwaltung fuer zukuenftiges Wachstum wuenschen',
      'Hotels, die fortschrittliches Ertragsmanagement ueber grundlegende Tariffestlegung hinaus suchen',
    ],
  },
  faqItems: [
    { question: 'Kann ich von innRoad zu HotelStack.io migrieren?', answer: 'Ja. Unser Migrationsteam uebernimmt den vollstaendigen Datentransfer von innRoad einschliesslich Gaesteprofilen, Reservierungshistorie, Tarifplaenen und Zimmerkonfigurationen. Die Migration ist kostenlos und wird in der Regel innerhalb von 48 Stunden ohne Ausfallzeiten abgeschlossen.' },
    { question: 'Unterstuetzt HotelStack.io unabhaengige US-Hotels wie innRoad?', answer: 'Absolut. HotelStack.io unterstuetzt unabhaengige Hotels in den USA und ueber 40 weiteren Laendern. US-Hotels erhalten alle 36 Module einschliesslich Funktionen, die innRoad nicht bietet, wie F&B/POS, Ertragsmanagement und Multi-Property-Support — ab $49/Monat.' },
    { question: 'Wie vergleicht sich HotelStack.io mit innRoad bei der GDS-Anbindung?', answer: 'Beide Plattformen bieten GDS-Anbindung ueber Amadeus und Sabre. HotelStack.io verbindet sich zusaetzlich mit 100+ OTAs weltweit, bietet Metasuche-Integration und umfasst eine provisionsfreie Buchungsmaschine (BookMyRoom.io) — alles im Grundpreis enthalten.' },
    { question: 'Kann HotelStack.io mehrere Objekte verwalten, anders als innRoad?', answer: 'Ja. HotelStack.io umfasst vollstaendige Kettenverwaltung mit zentralisiertem Dashboard, objektuebergreifenden Analysen, gemeinsamer Tarif-Distribution, Markenstandards-Durchsetzung und konsolidierter Berichterstattung. innRoad ist fuer den Einzelobjektbetrieb konzipiert.' },
  ],
};

const WEBREZPRO_DE: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io vs WebRezPro',
  heroSubtitle: 'WebRezPro ist ein kanadisches Cloud-PMS mit Buchhaltungsfokus fuer kleine bis mittlere Hotels. HotelStack.io bietet eine moderne, funktionsreiche Plattform mit 36 Modulen, Enterprise-Grade-Oberflaeche, erweiterten Ertragstools und vollstaendigem F&B/POS — entwickelt fuer die naechste Generation der Hotellerie.',
  overviewComparison: [
    { label: 'Module gesamt', hotelstack: '36 integrierte Module', competitor: '10+ Kernfunktionen' },
    { label: 'Preise', hotelstack: 'Ab $49/Monat', competitor: 'Ab $75+/Monat' },
    { label: 'UI/UX-Qualitaet', hotelstack: 'Modernes Luxus-Dunkeldesign', competitor: 'Funktional / Veraltet' },
    { label: 'F&B / POS', hotelstack: 'Integriert', competitor: 'Nicht verfuegbar' },
    { label: 'Ertragsmanagement', hotelstack: 'Erweitert (integriert)', competitor: 'Basis-Tariftools' },
    { label: 'Multi-Property', hotelstack: 'Vollstaendige Kettenverwaltung', competitor: 'Eingeschraenkt' },
  ],
  featureTable: [
    {
      category: 'Kern-PMS',
      features: [
        { name: 'Cloud-basiertes PMS', hotelstack: true, competitor: true },
        { name: 'Visuelle Zimmertafel', hotelstack: true, competitor: true },
        { name: 'Reservierungsverwaltung', hotelstack: true, competitor: true },
        { name: 'Nachtabschluss-Assistent', hotelstack: true, competitor: true },
        { name: 'Gastefolio-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Online Check-In Portal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Buchhaltung & Finanzen',
      features: [
        { name: 'Integrierte Buchhaltung', hotelstack: true, competitor: true },
        { name: 'Gewinn- und Verlustrechnung', hotelstack: true, competitor: true },
        { name: 'Forderungsmanagement', hotelstack: true, competitor: true },
        { name: 'Mehrwaehrungsabrechnung', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Regionale Steuerkonformitaet', hotelstack: true, competitor: 'CAD/USD-Fokus' },
        { name: 'Individuelle Rechnungsvorlagen', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Ertrag & Distribution',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'Weniger OTAs' },
        { name: 'Dynamische Preisregeln', hotelstack: true, competitor: 'Basis' },
        { name: 'Was-Waere-Wenn-Ertragssimulator', hotelstack: true, competitor: false },
        { name: 'Wettbewerbspreise-Monitor', hotelstack: true, competitor: false },
        { name: 'Nachfrageprognose', hotelstack: true, competitor: false },
        { name: 'Provisionsfreie Buchungsmaschine', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'F&B & Betrieb',
      features: [
        { name: 'POS-Terminal', hotelstack: true, competitor: false },
        { name: 'Zimmerservice-Modul', hotelstack: true, competitor: false },
        { name: 'Kuechenanzeigesystem', hotelstack: true, competitor: false },
        { name: 'Housekeeping-Verwaltung', hotelstack: true, competitor: true },
        { name: 'Wartungsauftraege', hotelstack: true, competitor: false },
        { name: 'Personalplanung', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Gaeste & Enterprise',
      features: [
        { name: '360-Grad-Gaesteprofile', hotelstack: true, competitor: 'Basis' },
        { name: 'Treueprogramm-Verwaltung', hotelstack: true, competitor: false },
        { name: 'Gaestekommunikation-Automatisierung', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Ketten-Dashboard', hotelstack: true, competitor: 'Eingeschraenkt' },
        { name: 'Objektuebergreifende Analysen', hotelstack: true, competitor: false },
        { name: 'Markenstandards-Durchsetzung', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resilienz & Offline',
      features: [
        { name: 'Offlinefaehige PWA', hotelstack: true, competitor: false },
        { name: 'Offline-Warteschlange fuer Aenderungen', hotelstack: true, competitor: false },
        { name: 'Hintergrundsynchronisierung bei Wiederverbindung', hotelstack: true, competitor: false },
        { name: 'Konfliktbewusster Abgleich', hotelstack: true, competitor: false },
        { name: 'Installierbare Rezeption', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Firmenkunden & Gruppenverkauf',
      features: [
        { name: 'Firmenratenverwaltung', hotelstack: true, competitor: false },
        { name: 'Gruppenbuchung mit Zimmerlisten', hotelstack: true, competitor: false },
        { name: 'Offene-Posten- & Produktionsberichte', hotelstack: true, competitor: false },
        { name: 'Restaurantreservierungen', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal & HR',
      features: [
        { name: 'Mitarbeiterverzeichnis & Dienstplanung', hotelstack: true, competitor: false },
        { name: 'Lohnabrechnung', hotelstack: true, competitor: false },
        { name: 'Urlaub & Anwesenheit', hotelstack: true, competitor: false },
        { name: 'Leistungsanalysen', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: 'Alle 36 Module enthalten. Moderne Enterprise-Grade-Oberflaeche. Regionale Preise in EUR, GBP, AED, INR, THB. Kostenloses Onboarding und Migration.',
    competitorNote: 'Pro-Zimmer-Preise ab $75+/Monat CAD. Funktionale aber veraltete Oberflaeche. Eingeschraenkte F&B, eingeschraenkte Multi-Property, hauptsaechlich nordamerikanischer Support.',
  },
  advantages: [
    'Ueber dreimal so viele Module (36 vs. 10+) mit einer modernen Enterprise-Grade-Oberflaeche',
    'Vollstaendiges F&B-Modul mit POS, Zimmerservice und Kuechenmanagement enthalten',
    'Fortschrittliches Ertragsmanagement mit dynamischer Preisgestaltung, Prognose und Was-Waere-Wenn-Simulatoren',
    'Modernes dunkles Luxus-Design fuer 2026 vs. WebRezPro funktionale aber veraltete Oberflaeche',
    'Vollstaendige Multi-Property-Kettenverwaltung mit zentralisierten Analysen und Tarif-Distribution',
    'Globale Reichweite in ueber 40 Laendern vs. WebRezPro nordamerikanischer Fokus',
    'Treueprogramm, Gaeste-CRM und automatisierte Kommunikation fuer Wiederholungsbuchungen',
    'Kostenloses Onboarding und Datenmigration mit 24/7 dediziertem Support',
  ],
  verdict: {
    title: 'Unser Fazit',
    summary: 'WebRezPro ist ein zuverlaessiges kanadisches PMS mit starken Buchhaltungsfunktionen fuer kleine bis mittlere nordamerikanische Hotels. Die veraltete Oberflaeche, der eingeschraenkte Funktionsumfang und das Fehlen von F&B, erweiterten Ertragstools und Enterprise-Skalierbarkeit machen es jedoch 2026 zu einer weniger wettbewerbsfaehigen Wahl. HotelStack.io bietet eine moderne, umfassende Plattform, die WebRezPro bei der Buchhaltung erreicht und 22+ weitere Module, eine erstklassige Oberflaeche und globale Funktionen hinzufuegt.',
    bestFor: [
      'Hotels, die ein modernes UI-Upgrade ohne Einbussen bei der Buchhaltungstiefe wuenschen',
      'Objekte, die F&B, POS und Kuechenmanagement ueber grundlegendes PMS hinaus benoetigen',
      'Hotels, die fortschrittliches Ertragsmanagement und dynamische Preistools suchen',
      'Objekte, die international ueber Nordamerika hinaus expandieren',
      'Wachsende Hotelgruppen, die vollstaendige Multi-Property-Kettenverwaltung benoetigen',
    ],
  },
  faqItems: [
    { question: 'Kann ich von WebRezPro zu HotelStack.io migrieren?', answer: 'Ja. Unser Migrationsteam uebernimmt den vollstaendigen Datentransfer von WebRezPro einschliesslich Gaesteprofilen, Reservierungshistorie, Tarifplaenen, Buchhaltungsdaten und Zimmerkonfigurationen. Die Migration ist kostenlos und wird in der Regel innerhalb von 48 Stunden ohne Ausfallzeiten abgeschlossen.' },
    { question: 'Erreicht HotelStack.io die Buchhaltungsfunktionen von WebRezPro?', answer: 'Ja. HotelStack.io umfasst integrierte Buchhaltung, Gewinn- und Verlustrechnung, Forderungsmanagement, individuelle Rechnungsstellung und Mehrwaehrungsabrechnung. Zusaetzlich bietet es 22+ weitere Module einschliesslich F&B, Ertragsmanagement, Gaeste-CRM und Multi-Property-Verwaltung, die WebRezPro nicht bietet.' },
    { question: 'Wie vergleicht sich die Oberflaeche von HotelStack.io mit WebRezPro?', answer: 'HotelStack.io verfuegt ueber eine moderne dunkle Luxus-Oberflaeche, die mit den neuesten Webtechnologien entwickelt wurde und responsives Design auf allen Geraeten bietet. WebRezPro hat eine funktionale aber veraltete Oberflaeche, die fuer eine fruehere Aera von Webanwendungen entworfen wurde.' },
    { question: 'Ist HotelStack.io fuer kanadische Objekte geeignet, die derzeit WebRezPro nutzen?', answer: 'Absolut. HotelStack.io unterstuetzt Mehrwaehrungsabrechnung einschliesslich CAD, kanadische Steuerkonformitaet (GST/HST/PST) und verbindet sich mit allen grossen nordamerikanischen OTAs. Viele kanadische Objekte wechseln wegen der zusaetzlichen Module und modernen Erfahrung.' },
  ],
};


export const COMPARISON_DE_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_DE,
  'hotelstack-vs-webrezpro': WEBREZPRO_DE,
};
